const CHAT_URL = 'https://n8n.arctos.tw/chat/arcforge-agent-chat';

export function ChatWidget() {
  const open = () => {
    window.open(
      CHAT_URL,
      'arcforge-chat',
      'width=420,height=640,menubar=no,toolbar=no,location=no,status=no'
    );
  };
  return (
    <button
      onClick={open}
      className="fixed bottom-4 right-4 z-40 rounded-full bg-arcforge-700 px-5 py-3 text-white shadow-lg hover:bg-arcforge-500 transition"
      aria-label="開啟 Arcforge Chat"
    >
      💬 Arcforge Chat
    </button>
  );
}
